// extracted by mini-css-extract-plugin
export default {"cls1":"TruncateHeight-cls1_DC1","cls2":"TruncateHeight-cls2_iXn TruncateHeight-cls1_DC1"};